import { io } from 'socket.io-client';

let socket = null;

export function getSocket() {
  if (!socket) {
    // In dev, frontend is on port 3000/3002, backend on 3001
    // In production, same origin
    const url = process.env.NODE_ENV === 'development'
      ? 'http://localhost:3001'
      : undefined;

    socket = io(url || window.location.origin, {
      withCredentials: true,
      autoConnect: false,
    });
  }
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  if (!s.connected) {
    s.connect();
  }
  return s;
}

export function disconnectSocket() {
  if (socket && socket.connected) {
    socket.disconnect();
  }
}
